/* Count-up animation for .review-count-up spans rendered by
   snippets/review-count-text.liquid. The true value is already in the HTML
   (SEO/AEO safe); this only animates its arrival when scrolled into view. */
(function () {
  var els = document.querySelectorAll('.review-count-up');
  if (!els.length || !('IntersectionObserver' in window)) return;

  function animate(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (!target) return;
    var start = Math.max(0, target - 150);
    var duration = 2000;
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(start + (target - start) * eased).toLocaleString('en-US');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        io.unobserve(entry.target);
        animate(entry.target);
      }
    });
  }, { threshold: 0.5 });

  els.forEach(function (el) { io.observe(el); });
})();
